
import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import { fetchAPI } from "@/utility/NetworkUtils";
import {
  Button,
} from "@mui/material"
import Modal from "react-modal";
import ReceivingItemReceiveForm from "./ReceivingItemReceiveForm";
const ReceivingListRecieveModal = ({
  closeModal,
  open,
  item,
  receivingItemId
}) => {
  const [ loading, setLoading ] = useState(true);
  const [ receivingItem, setReceivingItem ] = useState(null);
  
  useEffect(() => {
    if(open) {
      setLoading(true)
      if(receivingItemId) {
        fetchAPI(`/webapi/receiving_items/${receivingItemId}`, (json)=> {
          if (!json.errors) {
            setReceivingItem(json.receiving_item)
          } else {
            console.log({
              errors: json.errors
            })
          }
          setLoading(false)
        }, {});
      }else {
        setLoading(false)
      }
    }else {
      setReceivingItem(null)
    }
  }, [open, receivingItemId])

  return (
    <Modal
      className="react-modal sg-receiving-list-modal"
      overlayClassName="react-modal-overlay"
      isOpen={open}
      onRequestClose={closeModal}
    >
      {loading ? (
        <h1>
          Loading
        </h1>
      ): (
        <>
          <ReceivingItemReceiveForm
            item={item}
            receivingItem={receivingItem}
            onCancel={closeModal}
            onSubmit={closeModal}
          /> 
        </>
      )}
 
    </Modal>
  )
}

export default ReceivingListRecieveModal